import{p as r}from"../../../pdfjs-dist/legacy/build/pdf.js";export{default as Document}from"./Document.js";import"./Outline.js";export{default as Page}from"./Page.js";import{displayWorkerWarning as o}from"./shared/utils.js";o(),r.GlobalWorkerOptions.workerSrc="pdf.worker.js";
//# sourceMappingURL=entry.js.map
